<template>
  <div>
    CHANNEL
    <hr>
    <b-form-group :class="{'error-input' : $v.data_channel.channel.$error}">
      <label> Select Channel </label>
      <j-single-select
        v-model="$v.data_channel.channel.$model"
        :options="list_channel"
        :placeholder="`Choose Channel`"
        label="name"
        value-format="object"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeChannel">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveChannel">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_channel: {
      channel: {
        required,
      },
    },
  },
  data() {
    return {
      data_channel: {
        channel: null,
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_channel']),

    generateDataChannel() {
      const infoName = this.data_channel.channel.name;
      const data = {
        info: JSON.stringify({
          id: this.data_channel.channel.id,
          name: infoName.toLowerCase().replace(/\s/g, '-'),
        }),
        value_id: `${this.data_channel.channel.id}`,
        name: this.data_channel.channel.name,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataChannelUpdate() {
      const infoName = this.data_channel.channel.name;
      const data = {
        info: JSON.stringify({
          id: this.data_channel.channel.id,
          name: infoName.toLowerCase().replace(/\s/g, '-'),
        }),
        value_id: `${this.data_channel.channel.id}`,
        name: this.data_channel.channel.name,
        widget_master_id: this.dataMaster.id,


        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    this.getListChannel();

    if (this.modeEdit) {
      this.data_channel.channel = {
        id: JSON.parse(this.dataEdit.info).id,
        name: JSON.parse(this.dataEdit.info).name,
      };
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget', 'getListChannel']),

    saveChannel() {
      this.$v.data_channel.$touch();
      if (!this.$v.data_channel.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataChannel;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataChannelUpdate;
          this.updateWidget({ widgetId, dataParam });
        }

        this.closeChannel();
      }
    },

    closeChannel() {
      this.$emit('close-field');
      this.data_channel.channel = null;
      setTimeout(() => {
        this.$v.data_channel.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jChannelSetup.vue